import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { ApiCore } from '../../../api/index';
import { Switch, Toast, Button } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import close from '../../../static/images_cso/close.png';
import shop from '../../../static/images_cso/shop.png';

const api = new ApiCore();

const NoInventory = (props: any, refs: any) => {

    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [text, setText] = useState<string>('');

    useEffect(() => {
        if (props.text) {
            setText(props.text);
        }
        return () => {
        }
    }, [props.text])

    // 展示弹框
    useImperativeHandle(refs, () => ({
        toShow,
        toClose
    }));

    const toShow = () => {
        setShowDialog(true);
    }

    const toClose = () => {
        setShowDialog(false);
    }

    return (
        <div className={styles.no_inventory_content} style={{ display: showDialog ? 'block' : 'none' }}>
             <div className={styles.dialog}>
                <div className={styles.shop_wrap}>
                    <img src={shop} alt="" />
                </div>
                {
                    !text ?
                    <div className={styles.word}>该治疗建议下药品暂无库存，请选择其他治疗方案</div>
                    :
                    <div className={styles.word} style={{ textAlign: 'center' }}>{ text }</div>
                }
                <div className={styles.close_wrap}>
                    <img src={close} onClick={toClose} alt="" />
                </div>
             </div>
             <div className={styles.mask}></div>
        </div>
    )
}

export default forwardRef(NoInventory);